<div class="container-filter-cards">
    <div class="container-breadcrumb">
        <p id="id-breadcrumb-tab-benefits" class="copec-lg-14">Admin / <span class="ruta"> Beneficios /</span></p>
    </div>
    <div class="container-button-subtitle">
        <div class="box-button1"><span class="copec-bold-30">Beneficios</span></div>
        <div class="box-button2">
          <button class="button-profiles" (click)="goAddBenefits(null)">Crear Nuevo Beneficio</button>
        </div>
      </div>
      <div class="container-search-order">
    <div class="search-bar">
          <i class="fa-solid fa-magnifying-glass"></i>
          <input
          (input) ="onSearch()"
          [(ngModel)]="searchTerm"
            maxlength="70"
            type="text"
            placeholder="Buscar"
            #input
            />
        </div>
        <div>
          <select class="ordenarPor" [(ngModel)]="selectedSortOption" (change)="onSortChange()" >
            <option value="order">Ordenar por</option>
            <option value="mostOld">De antiguo a reciente</option>
            <option value="actually">De reciente a antiguos</option>
            <option value="ordertoA">A-Z</option>
            <option value="ordertoZ">Z-A</option>
          </select>
        </div>
      </div>

      <div  *ngIf="benefits">
        <table
          mat-table
          [dataSource]="paginatedBenefits"
          class="table-responsive mat-elevation-z8"
          aria-label="Beneficios"

        >
          <ng-container matColumnDef="title" removeRowDef>
            <th mat-header-cell *matHeaderCellDef class="display-none">Beneficio</th>
            <td
              mat-cell
              *matCellDef="let element"
              remove
              class="display-none"
              RowDef
            >
              {{ element.title }}
            </td>
          </ng-container>

          <ng-container matColumnDef="DescriptionCategories">
            <th mat-header-cell *matHeaderCellDef class="display-none">Categorías</th>
            <td mat-cell *matCellDef="let element" class="display-none">
              <ng-container *ngFor="let categoria of element.descriptionCategories">
                {{categoria.nombre}}
                <br>
              </ng-container>
            </td>
          </ng-container>

          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef class="display-none">ID Beneficios</th>
            <td mat-cell *matCellDef="let element" class="display-none">
              {{ element.id }}
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef class="display-none">
              Fecha de publicación
            </th>
            <td mat-cell *matCellDef="let element" class="display-none">
              {{ utils.formatDateAlternative(element.createdAt) }}
            </td>
          </ng-container>

           <ng-container matColumnDef="statusbt">
            <th mat-header-cell *matHeaderCellDef class="display-none">Estado</th>
            <td mat-cell *matCellDef="let element" class="display-none">
              <mat-chip
                mat-chip
                [ngClass]="{
                  'chip-activo': element.vigencia === true ? false : element.hidden === false,
                  'chip-inactivo': element.vigencia === true ? false : element.hidden === true,
                  'chip-deshabilitado': element.vigencia === true
                }"
                
                [disabled]="
                  element.vigencia === true || element.hidden === true
                "
              >
              <div class="clip-text">
                {{ element.vigencia === true ? 'Deshabilitado' : (element.hidden === true ? 'Oculto' : 'Publicado') }}
              </div>
              </mat-chip>
            </td>
          </ng-container>

          <ng-container matColumnDef="editar">
            <th mat-header-cell *matHeaderCellDef class="display-none"></th>
            <td mat-cell *matCellDef="let element" class="display-none">
               <div mat-menu-item class="three-dots" [matMenuTriggerFor]="menu"></div>
                <mat-menu #menu="matMenu">
                  <button (click)="goAddBenefits(element)" mat-menu-item>
                    <mat-icon class="edit"></mat-icon>
                    <span>Editar</span>
                  </button>
                  <button (click)="statusChange(element.id, element.hidden)" mat-menu-item
                  >
                    <mat-icon [ngClass]=" element.hidden ? 'check' : ''"> {{!element.hidden ? 'highlight_off':''}}</mat-icon>
                    <span>{{element.hidden ? 'Publicar': 'Ocultar'}}</span>
                  </button>
                
                </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="6">
              No se encontraron resultados para "{{ input.value }}"
            </td>
          </tr>
        </table>
      </div>
      <div id="ben-div-6" *ngIf="benefits">
        <div>

          <div class="container-paginated">
            <div class="mostrandoPage">
             <span id="pag-span-1" *ngIf="isSizeMobile">
               {{ currentPage }} de {{ totalPages }}</span
             >
             <span id="pag-span-2" *ngIf="!isSizeMobile"
               >Mostrando {{ currentPage }} de {{ totalPages }} </span
             >
           </div><div class="mostrandoPage2"><span id="pag-span-2" *ngIf="!isSizeMobile"
             > Tabla por página:</span></div>
           <div>
             <select (click)="onSelecPageChange($event)" class="nregistros">
               <option value="15">15</option>
               <option value="10">10</option>
               <option value="5">5</option>
             </select>
           </div>
           <div><app-paginator-select id="ben-app-4"
             [currentPage]="currentPage"
             [totalPages]="totalPages"
             (pageChange)="onPageChange($event)"
           ></app-paginator-select></div>
        </div>


      </div>
         <ng-template #noResults id="ben-template-1">
      <div id="ben-div-9" class="noFound d-flex align-items-center">
        <img id="ben-imagen-1" class="fa-regular" src="/assets/img/no_results.svg" alt=""/>
      </div>
    </ng-template>
  </div>
</div>
